module.exports = "pegasus/assets/theme4/small/1.jpg";